var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 270,
    viewBox: "0 0 222 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.847 57.5832L119.11 0L119.11 116.293L218.847 173.877L218.847 57.5832Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 12.9016L125.351 10.8889L125.351 14.9545L128.837 16.9672L128.837 12.9016Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.323 14.9141L128.836 12.9014L128.836 16.967L132.323 18.9797L132.323 14.9141Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 16.9267L132.323 14.9141L132.323 18.9797L135.809 20.9924L135.809 16.9267Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 18.9394L135.809 16.9268L135.809 20.9924L139.295 23.0051L139.295 18.9394Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 20.9723L139.33 18.9596L139.33 23.0252L142.816 25.0379L142.816 20.9723Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.302 22.985L142.816 20.9723L142.816 25.0379L146.302 27.0506L146.302 22.985Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 24.9976L146.302 22.985L146.302 27.0506L149.788 29.0633L149.788 24.9976Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 29.023L153.274 27.0103L153.274 31.076L156.76 33.0887L156.76 29.023Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 31.0357L156.76 29.023L156.76 33.0887L160.246 35.1014L160.246 31.0357Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 33.0484L160.246 31.0357L160.246 35.1014L163.732 37.1141L163.732 33.0484Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 35.0812L163.767 33.0686L163.767 37.1342L167.253 39.1469L167.253 35.0812Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 49.1701L188.17 47.1574L188.17 51.2231L191.656 53.2357L191.656 49.1701Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 51.2029L191.69 49.1902L191.69 53.2559L195.177 55.2686L195.177 51.2029Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 53.2156L195.177 51.2029L195.177 55.2686L198.663 57.2813L198.663 53.2156Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 55.2283L198.663 53.2156L198.663 57.2813L202.149 59.294L202.149 55.2283Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 57.241L202.149 55.2283L202.149 59.2939L205.635 61.3066L205.635 57.241Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 59.2537L205.635 57.241L205.635 61.3066L209.121 63.3193L209.121 59.2537Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 61.2664L209.121 59.2537L209.121 63.3193L212.607 65.332L212.607 61.2664Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 16.967L125.351 14.9543L125.351 19.0199L128.837 21.0326L128.837 16.967Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 29.0633L146.302 27.0506L146.302 31.1162L149.788 33.1289L149.788 29.0633Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 39.1469L163.767 37.1342L163.767 41.1998L167.253 43.2125L167.253 39.1469Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 41.1596L167.253 39.1469L167.253 43.2125L170.74 45.2252L170.74 41.1596Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 43.1723L170.739 41.1596L170.739 45.2252L174.225 47.2379L174.225 43.1723Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 45.185L174.225 43.1723L174.225 47.2379L177.711 49.2506L177.711 45.185Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 49.2104L181.197 47.1977L181.197 51.2633L184.683 53.276L184.683 49.2104Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 53.2357L188.17 51.223L188.17 55.2887L191.656 57.3014L191.656 53.2357Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 65.332L209.121 63.3193L209.121 67.385L212.607 69.3977L212.607 65.332Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 21.0326L125.351 19.02L125.351 23.0856L128.837 25.0983L128.837 21.0326Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 25.058L132.323 23.0453L132.323 27.111L135.809 29.1237L135.809 25.058Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 27.0707L135.809 25.058L135.809 29.1237L139.295 31.1364L139.295 27.0707Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 29.1036L139.33 27.0909L139.33 31.1565L142.816 33.1692L142.816 29.1036Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 33.1289L146.302 31.1162L146.302 35.1819L149.788 37.1946L149.788 33.1289Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 39.167L156.76 37.1543L156.76 41.22L160.246 43.2327L160.246 39.167Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 43.2125L163.767 41.1998L163.767 45.2655L167.253 47.2782L167.253 43.2125Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 47.2379L170.739 45.2252L170.739 49.2909L174.225 51.3035L174.225 47.2379Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 51.2633L177.712 49.2506L177.712 53.3163L181.198 55.3289L181.198 51.2633Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 53.276L181.197 51.2633L181.197 55.3289L184.683 57.3416L184.683 53.276Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 57.3014L188.17 55.2887L188.17 59.3543L191.656 61.367L191.656 57.3014Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 61.3469L195.177 59.3342L195.177 63.3998L198.663 65.4125L198.663 61.3469Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 63.3596L198.663 61.3469L198.663 65.4125L202.149 67.4252L202.149 63.3596Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 65.3723L202.149 63.3596L202.149 67.4252L205.635 69.4379L205.635 65.3723Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 69.3977L209.121 67.385L209.121 71.4506L212.607 73.4633L212.607 69.3977Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 25.0983L125.351 23.0856L125.351 27.1512L128.837 29.1639L128.837 25.0983Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 29.1237L132.323 27.111L132.323 31.1766L135.809 33.1893L135.809 29.1237Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 31.1364L135.809 29.1237L135.809 33.1893L139.295 35.202L139.295 31.1364Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 33.1692L139.33 31.1565L139.33 35.2221L142.816 37.2348L142.816 33.1692Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 37.1946L146.302 35.1819L146.302 39.2475L149.788 41.2602L149.788 37.1946Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 45.2454L160.246 43.2327L160.246 47.2983L163.732 49.311L163.732 45.2454Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 47.2782L163.767 45.2655L163.767 49.3311L167.253 51.3438L167.253 47.2782Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 51.3036L170.739 49.2909L170.739 53.3565L174.225 55.3692L174.225 51.3036Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 55.3289L177.712 53.3162L177.712 57.3819L181.198 59.3946L181.198 55.3289Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 57.3416L181.197 55.3289L181.197 59.3946L184.683 61.4073L184.683 57.3416Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 61.367L188.17 59.3543L188.17 63.42L191.656 65.4327L191.656 61.367Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 65.4125L195.177 63.3998L195.177 67.4655L198.663 69.4782L198.663 65.4125Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 67.4252L198.663 65.4125L198.663 69.4782L202.149 71.4909L202.149 67.4252Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 69.4379L202.149 67.4252L202.149 71.4909L205.635 73.5036L205.635 69.4379Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 73.4633L209.121 71.4506L209.121 75.5163L212.607 77.529L212.607 73.4633Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 29.1639L125.351 27.1512L125.351 31.2169L128.837 33.2296L128.837 29.1639Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 33.1893L132.323 31.1766L132.323 35.2423L135.809 37.255L135.809 33.1893Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 35.202L135.809 33.1893L135.809 37.2549L139.295 39.2676L139.295 35.202Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 37.2348L139.33 35.2221L139.33 39.2878L142.816 41.3005L142.816 37.2348Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 41.2602L146.302 39.2475L146.302 43.3132L149.788 45.3258L149.788 41.2602Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 49.311L160.246 47.2983L160.246 51.3639L163.732 53.3766L163.732 49.311Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 51.3438L163.767 49.3311L163.767 53.3968L167.253 55.4094L167.253 51.3438Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 53.3565L167.253 51.3438L167.253 55.4094L170.74 57.4221L170.74 53.3565Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 57.3819L174.225 55.3692L174.225 59.4348L177.711 61.4475L177.711 57.3819Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 61.4073L181.197 59.3946L181.197 63.4602L184.683 65.4729L184.683 61.4073Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 65.4327L188.17 63.42L188.17 67.4856L191.656 69.4983L191.656 65.4327Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 69.4782L195.177 67.4655L195.177 71.5311L198.663 73.5438L198.663 69.4782Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 71.4909L198.663 69.4782L198.663 73.5438L202.149 75.5565L202.149 71.4909Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 73.5036L202.149 71.4909L202.149 75.5565L205.635 77.5692L205.635 73.5036Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 77.529L209.121 75.5163L209.121 79.5819L212.607 81.5946L212.607 77.529Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 33.2296L125.351 31.2169L125.351 35.2825L128.837 37.2952L128.837 33.2296Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 45.3258L146.302 43.3132L146.302 47.3788L149.788 49.3915L149.788 45.3258Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 51.3639L156.76 49.3512L156.76 53.4169L160.246 55.4296L160.246 51.3639Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 55.4094L163.767 53.3968L163.767 57.4624L167.253 59.4751L167.253 55.4094Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 61.4475L174.225 59.4348L174.225 63.5005L177.711 65.5132L177.711 61.4475Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 65.4729L181.197 63.4602L181.197 67.5259L184.683 69.5386L184.683 65.4729Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 69.4983L188.17 67.4856L188.17 71.5513L191.656 73.5639L191.656 69.4983Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 81.5946L209.121 79.5819L209.121 83.6475L212.607 85.6602L212.607 81.5946Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 37.2952L125.351 35.2825L125.351 39.3482L128.837 41.3609L128.837 37.2952Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M132.323 39.3079L128.836 37.2952L128.836 41.3608L132.323 43.3735L132.323 39.3079Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 41.3206L132.323 39.3079L132.323 43.3735L135.809 45.3862L135.809 41.3206Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 43.3333L135.809 41.3206L135.809 45.3862L139.295 47.3989L139.295 43.3333Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 45.3661L139.33 43.3534L139.33 47.419L142.816 49.4317L142.816 45.3661Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M146.302 47.3788L142.816 45.3661L142.816 49.4318L146.302 51.4444L146.302 47.3788Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 49.3915L146.302 47.3788L146.302 51.4444L149.788 53.4571L149.788 49.3915Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 53.4169L153.274 51.4042L153.274 55.4698L156.76 57.4825L156.76 53.4169Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 57.4423L160.246 55.4296L160.246 59.4952L163.732 61.5079L163.732 57.4423Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 61.4878L167.253 59.4751L167.253 63.5407L170.74 65.5534L170.74 61.4878Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 65.5132L174.225 63.5005L174.225 67.5661L177.711 69.5788L177.711 65.5132Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 69.5386L181.197 67.5259L181.197 71.5915L184.683 73.6042L184.683 69.5386Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 73.5639L188.17 71.5512L188.17 75.6169L191.656 77.6296L191.656 73.5639Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 75.5968L191.69 73.5841L191.69 77.6497L195.177 79.6624L195.177 75.5968Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 77.6094L195.177 75.5968L195.177 79.6624L198.663 81.6751L198.663 77.6094Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 79.6222L198.663 77.6095L198.663 81.6751L202.149 83.6878L202.149 79.6222Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 81.6348L202.149 79.6222L202.149 83.6878L205.635 85.7005L205.635 81.6348Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 83.6475L205.635 81.6348L205.635 85.7005L209.121 87.7132L209.121 83.6475Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 85.6602L209.121 83.6475L209.121 87.7132L212.607 89.7259L212.607 85.6602Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 57.4825L153.274 55.4698L153.274 59.5355L156.76 61.5482L156.76 57.4825Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 59.4952L156.76 57.4825L156.76 61.5482L160.246 63.5608L160.246 59.4952Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 65.5534L167.253 63.5407L167.253 67.6064L170.74 69.6191L170.74 65.5534Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 67.5661L170.739 65.5534L170.739 69.6191L174.225 71.6317L174.225 67.5661Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 45.4668L125.351 43.4541L125.351 47.5197L128.837 49.5324L128.837 45.4668Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M132.323 47.4794L128.836 45.4667L128.836 49.5324L132.323 51.5451L132.323 47.4794Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 51.5048L135.809 49.4921L135.809 53.5578L139.295 55.5704L139.295 51.5048Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 53.5376L139.33 51.5249L139.33 55.5906L142.816 57.6033L142.816 53.5376Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 57.563L146.302 55.5503L146.302 59.616L149.788 61.6287L149.788 57.563Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 63.6011L156.76 61.5884L156.76 65.6541L160.246 67.6668L160.246 63.6011Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 69.6593L167.253 67.6466L167.253 71.7123L170.74 73.7249L170.74 69.6593Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 73.6847L174.225 71.672L174.225 75.7377L177.711 77.7503L177.711 73.6847Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 75.6974L177.712 73.6847L177.712 77.7504L181.198 79.763L181.198 75.6974Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 81.7355L188.17 79.7228L188.17 83.7884L191.656 85.8011L191.656 81.7355Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 93.8318L209.121 91.8191L209.121 95.8847L212.607 97.8974L212.607 93.8318Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 49.5324L125.351 47.5197L125.351 51.5853L128.837 53.598L128.837 49.5324Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M132.323 51.5451L128.836 49.5324L128.836 53.598L132.323 55.6107L132.323 51.5451Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 53.5578L132.323 51.5451L132.323 55.6107L135.809 57.6234L135.809 53.5578Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 57.6033L139.33 55.5906L139.33 59.6562L142.816 61.6689L142.816 57.6033Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M146.302 59.616L142.816 57.6033L142.816 61.6689L146.302 63.6816L146.302 59.616Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M153.274 63.6414L149.788 61.6287L149.788 65.6943L153.274 67.707L153.274 63.6414Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 69.6794L160.246 67.6667L160.246 71.7324L163.732 73.7451L163.732 69.6794Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 75.7376L170.739 73.7249L170.739 77.7906L174.225 79.8033L174.225 75.7376Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 77.7504L174.225 75.7377L174.225 79.8033L177.711 81.816L177.711 77.7504Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 79.763L177.712 77.7503L177.712 81.816L181.198 83.8287L181.198 79.763Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M188.17 83.7884L184.684 81.7757L184.684 85.8414L188.17 87.8541L188.17 83.7884Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 87.8339L191.69 85.8213L191.69 89.8869L195.177 91.8996L195.177 87.8339Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 89.8466L195.177 87.8339L195.177 91.8996L198.663 93.9123L198.663 89.8466Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 91.8593L198.663 89.8466L198.663 93.9123L202.149 95.925L202.149 91.8593Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 93.872L202.149 91.8593L202.149 95.925L205.635 97.9377L205.635 93.872Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 95.8847L205.635 93.872L205.635 97.9377L209.121 99.9504L209.121 95.8847Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 53.598L125.351 51.5853L125.351 55.651L128.837 57.6637L128.837 53.598Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 57.6234L132.323 55.6107L132.323 59.6764L135.809 61.6891L135.809 57.6234Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 61.6689L139.33 59.6562L139.33 63.7219L142.816 65.7346L142.816 61.6689Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 65.6943L146.302 63.6816L146.302 67.7473L149.788 69.76L149.788 65.6943Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M153.274 67.707L149.788 65.6943L149.788 69.76L153.274 71.7726L153.274 67.707Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 69.7197L153.274 67.707L153.274 71.7727L156.76 73.7853L156.76 69.7197Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 71.7324L156.76 69.7197L156.76 73.7853L160.246 75.798L160.246 71.7324Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 77.7906L167.253 75.7779L167.253 79.8436L170.74 81.8563L170.74 77.7906Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 83.8287L177.712 81.816L177.712 85.8816L181.198 87.8943L181.198 83.8287Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 85.8414L181.197 83.8287L181.197 87.8943L184.683 89.907L184.683 85.8414Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 89.8668L188.17 87.8541L188.17 91.9197L191.656 93.9324L191.656 89.8668Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 91.8996L191.69 89.8869L191.69 93.9525L195.177 95.9652L195.177 91.8996Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 95.925L198.663 93.9123L198.663 97.9779L202.149 99.9906L202.149 95.925Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 101.963L209.121 99.9504L209.121 104.016L212.607 106.029L212.607 101.963Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 57.6637L125.351 55.651L125.351 59.7166L128.837 61.7293L128.837 57.6637Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M132.323 59.6764L128.836 57.6637L128.836 61.7293L132.323 63.742L132.323 59.6764Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M153.274 71.7727L149.788 69.76L149.788 73.8256L153.274 75.8383L153.274 71.7727Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 73.7853L153.274 71.7726L153.274 75.8383L156.76 77.851L156.76 73.7853Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 87.8943L177.712 85.8816L177.712 89.9473L181.198 91.96L181.198 87.8943Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 95.9652L191.69 93.9525L191.69 98.0182L195.177 100.031L195.177 95.9652Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 99.9906L198.663 97.9779L198.663 102.044L202.149 104.056L202.149 99.9906Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 102.003L202.149 99.9906L202.149 104.056L205.635 106.069L205.635 102.003Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 104.016L205.635 102.003L205.635 106.069L209.121 108.082L209.121 104.016Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 106.029L209.121 104.016L209.121 108.082L212.607 110.094L212.607 106.029Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 65.7547L132.323 63.742L132.323 67.8076L135.809 69.8203L135.809 65.7547Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 67.7674L135.809 65.7547L135.809 69.8203L139.295 71.833L139.295 67.7674Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 73.8256L146.302 71.8129L146.302 75.8785L149.788 77.8912L149.788 73.8256Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 77.851L153.274 75.8383L153.274 79.9039L156.76 81.9166L156.76 77.851Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 79.8637L156.76 77.851L156.76 81.9166L160.246 83.9293L160.246 79.8637Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 81.8764L160.246 79.8637L160.246 83.9293L163.732 85.942L163.732 81.8764Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 89.9473L174.225 87.9346L174.225 92.0002L177.711 94.0129L177.711 89.9473Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 91.96L177.712 89.9473L177.712 94.0129L181.198 96.0256L181.198 91.96Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 97.998L188.17 95.9853L188.17 100.051L191.656 102.064L191.656 97.998Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 110.094L209.121 108.082L209.121 112.147L212.607 114.16L212.607 110.094Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 65.795L125.351 63.7823L125.351 67.8479L128.837 69.8606L128.837 65.795Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 69.8203L132.323 67.8076L132.323 71.8733L135.809 73.886L135.809 69.8203Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 71.833L135.809 69.8203L135.809 73.886L139.295 75.8987L139.295 71.833Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M146.302 75.8785L142.816 73.8658L142.816 77.9315L146.302 79.9442L146.302 75.8785Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M153.274 79.9039L149.788 77.8912L149.788 81.9569L153.274 83.9696L153.274 79.9039Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 85.942L160.246 83.9293L160.246 87.9949L163.732 90.0076L163.732 85.942Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 89.9875L167.253 87.9748L167.253 92.0405L170.74 94.0531L170.74 89.9875Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 94.0129L174.225 92.0002L174.225 96.0658L177.711 98.0785L177.711 94.0129Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 96.0256L177.712 94.0129L177.712 98.0785L181.198 100.091L181.198 96.0256Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 98.0383L181.197 96.0256L181.197 100.091L184.683 102.104L184.683 98.0383Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M188.17 100.051L184.684 98.0383L184.684 102.104L188.17 104.117L188.17 100.051Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 106.109L195.177 104.096L195.177 108.162L198.663 110.175L198.663 106.109Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 112.147L205.635 110.135L205.635 114.2L209.121 116.213L209.121 112.147Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 69.8606L125.351 67.8479L125.351 71.9135L128.837 73.9262L128.837 69.8606Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M132.323 71.8733L128.836 69.8606L128.836 73.9262L132.323 75.9389L132.323 71.8733Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 75.8987L135.809 73.886L135.809 77.9516L139.295 79.9643L139.295 75.8987Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 77.9315L139.33 75.9188L139.33 79.9844L142.816 81.9971L142.816 77.9315Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M146.302 79.9442L142.816 77.9315L142.816 81.9971L146.302 84.0098L146.302 79.9442Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 81.9569L146.302 79.9442L146.302 84.0098L149.788 86.0225L149.788 81.9569Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M153.274 83.9696L149.788 81.9569L149.788 86.0225L153.274 88.0352L153.274 83.9696Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 87.995L156.76 85.9823L156.76 90.0479L160.246 92.0606L160.246 87.995Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 98.0785L174.225 96.0658L174.225 100.131L177.711 102.144L177.711 98.0785Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 100.091L177.712 98.0786L177.712 102.144L181.198 104.157L181.198 100.091Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M188.17 104.117L184.684 102.104L184.684 106.17L188.17 108.182L188.17 104.117Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 106.129L188.17 104.117L188.17 108.182L191.656 110.195L191.656 106.129Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 110.175L195.177 108.162L195.177 112.228L198.663 114.24L198.663 110.175Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 112.188L198.663 110.175L198.663 114.24L202.149 116.253L202.149 112.188Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 114.2L202.149 112.188L202.149 116.253L205.635 118.266L205.635 114.2Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 116.213L205.635 114.2L205.635 118.266L209.121 120.279L209.121 116.213Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 118.226L209.121 116.213L209.121 120.279L212.607 122.291L212.607 118.226Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 73.9262L125.351 71.9135L125.351 75.9792L128.837 77.9919L128.837 73.9262Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M146.302 84.0098L142.816 81.9971L142.816 86.0628L146.302 88.0755L146.302 84.0098Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M153.274 88.0352L149.788 86.0225L149.788 90.0882L153.274 92.1009L153.274 88.0352Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 92.0606L156.76 90.0479L156.76 94.1136L160.246 96.1262L160.246 92.0606Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 98.1188L167.253 96.1061L167.253 100.172L170.74 102.184L170.74 98.1188Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 102.144L174.225 100.132L174.225 104.197L177.711 106.21L177.711 102.144Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 106.17L181.197 104.157L181.197 108.223L184.683 110.235L184.683 106.17Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M188.17 108.182L184.684 106.17L184.684 110.235L188.17 112.248L188.17 108.182Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 112.228L191.69 110.215L191.69 114.281L195.177 116.293L195.177 112.228Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 116.253L198.663 114.24L198.663 118.306L202.149 120.319L202.149 116.253Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 118.266L202.149 116.253L202.149 120.319L205.635 122.332L205.635 118.266Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 122.291L209.121 120.279L209.121 124.344L212.607 126.357L212.607 122.291Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 77.9919L125.351 75.9792L125.351 80.0448L128.837 82.0575L128.837 77.9919Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 82.0173L132.323 80.0046L132.323 84.0702L135.809 86.0829L135.809 82.0173Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 84.0299L135.809 82.0173L135.809 86.0829L139.295 88.0956L139.295 84.0299Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 86.0628L139.33 84.0501L139.33 88.1157L142.816 90.1284L142.816 86.0628Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 90.0882L146.302 88.0755L146.302 92.1411L149.788 94.1538L149.788 90.0882Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M153.274 92.1009L149.788 90.0882L149.788 94.1538L153.274 96.1665L153.274 92.1009Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 98.1389L160.246 96.1262L160.246 100.192L163.732 102.205L163.732 98.1389Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 100.172L163.767 98.1591L163.767 102.225L167.253 104.237L167.253 100.172Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 102.184L167.253 100.172L167.253 104.237L170.74 106.25L170.74 102.184Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 104.197L170.739 102.184L170.739 106.25L174.225 108.263L174.225 104.197Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 108.223L177.712 106.21L177.712 110.275L181.198 112.288L181.198 108.223Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 110.235L181.197 108.223L181.197 112.288L184.683 114.301L184.683 110.235Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M188.17 112.248L184.684 110.235L184.684 114.301L188.17 116.314L188.17 112.248Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 114.261L188.17 112.248L188.17 116.314L191.656 118.326L191.656 114.261Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 116.293L191.69 114.281L191.69 118.346L195.177 120.359L195.177 116.293Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 118.306L195.177 116.293L195.177 120.359L198.663 122.372L198.663 118.306Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 122.332L202.149 120.319L202.149 124.384L205.635 126.397L205.635 122.332Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 124.344L205.635 122.332L205.635 126.397L209.121 128.41L209.121 124.344Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 98.2194L153.274 96.2067L153.274 100.272L156.76 102.285L156.76 98.2194Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 100.232L156.76 98.2194L156.76 102.285L160.246 104.298L160.246 100.232Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 104.278L163.767 102.265L163.767 106.331L167.253 108.343L167.253 104.278Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 114.341L181.197 112.328L181.197 116.394L184.683 118.407L184.683 114.341Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 122.412L195.177 120.399L195.177 124.465L198.663 126.478L198.663 122.412Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 126.437L202.149 124.425L202.149 128.49L205.635 130.503L205.635 126.437Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 128.45L205.635 126.437L205.635 130.503L209.121 132.516L209.121 128.45Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 86.1634L125.351 84.1507L125.351 88.2164L128.837 90.2291L128.837 86.1634Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M132.323 88.1761L128.836 86.1634L128.836 90.2291L132.323 92.2418L132.323 88.1761Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 90.1888L132.323 88.1761L132.323 92.2417L135.809 94.2544L135.809 90.1888Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 92.2015L135.809 90.1888L135.809 94.2544L139.295 96.2671L139.295 92.2015Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 94.2343L139.33 92.2216L139.33 96.2873L142.816 98.2999L142.816 94.2343Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M146.302 96.247L142.816 94.2343L142.816 98.3L146.302 100.313L146.302 96.247Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 98.2597L146.302 96.247L146.302 100.313L149.788 102.325L149.788 98.2597Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 106.31L160.246 104.298L160.246 108.363L163.732 110.376L163.732 106.31Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 110.356L167.253 108.343L167.253 112.409L170.74 114.422L170.74 110.356Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 114.381L174.225 112.369L174.225 116.434L177.711 118.447L177.711 114.381Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 118.407L181.197 116.394L181.197 120.46L184.683 122.472L184.683 118.407Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 122.432L188.17 120.419L188.17 124.485L191.656 126.498L191.656 122.432Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 126.478L195.177 124.465L195.177 128.531L198.663 130.543L198.663 126.478Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 134.528L209.121 132.516L209.121 136.581L212.607 138.594L212.607 134.528Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 90.2291L125.351 88.2164L125.351 92.282L128.837 94.2947L128.837 90.2291Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 102.325L146.302 100.313L146.302 104.378L149.788 106.391L149.788 102.325Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 112.409L163.767 110.396L163.767 114.462L167.253 116.475L167.253 112.409Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 116.434L170.739 114.422L170.739 118.487L174.225 120.5L174.225 116.434Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 120.46L177.712 118.447L177.712 122.513L181.198 124.525L181.198 120.46Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 122.472L181.197 120.46L181.197 124.525L184.683 126.538L184.683 122.472Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 130.543L195.177 128.531L195.177 132.596L198.663 134.609L198.663 130.543Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 138.594L209.121 136.581L209.121 140.647L212.607 142.66L212.607 138.594Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 94.2947L125.351 92.282L125.351 96.3477L128.837 98.3603L128.837 94.2947Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 98.3201L132.323 96.3074L132.323 100.373L135.809 102.386L135.809 98.3201Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 100.333L135.809 98.3201L135.809 102.386L139.295 104.398L139.295 100.333Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 102.366L139.33 100.353L139.33 104.419L142.816 106.431L142.816 102.366Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 106.391L146.302 104.378L146.302 108.444L149.788 110.457L149.788 106.391Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 110.416L153.274 108.404L153.274 112.469L156.76 114.482L156.76 110.416Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 114.442L160.246 112.429L160.246 116.495L163.732 118.507L163.732 114.442Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 116.475L163.767 114.462L163.767 118.528L167.253 120.54L167.253 116.475Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 118.487L167.253 116.475L167.253 120.54L170.74 122.553L170.74 118.487Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 122.513L174.225 120.5L174.225 124.566L177.711 126.578L177.711 122.513Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 124.525L177.712 122.513L177.712 126.578L181.198 128.591L181.198 124.525Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 126.538L181.197 124.525L181.197 128.591L184.683 130.604L184.683 126.538Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M188.17 128.551L184.684 126.538L184.684 130.604L188.17 132.616L188.17 128.551Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 130.563L188.17 128.551L188.17 132.616L191.656 134.629L191.656 130.563Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 132.596L191.69 130.584L191.69 134.649L195.177 136.662L195.177 132.596Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 134.609L195.177 132.596L195.177 136.662L198.663 138.675L198.663 134.609Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 98.3604L125.351 96.3477L125.351 100.413L128.837 102.426L128.837 98.3604Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 102.386L132.323 100.373L132.323 104.439L135.809 106.451L135.809 102.386Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 104.398L135.809 102.386L135.809 106.451L139.295 108.464L139.295 104.398Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 106.431L139.33 104.419L139.33 108.484L142.816 110.497L142.816 106.431Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 110.457L146.302 108.444L146.302 112.51L149.788 114.522L149.788 110.457Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 114.482L153.274 112.469L153.274 116.535L156.76 118.548L156.76 114.482Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 116.495L156.76 114.482L156.76 118.548L160.246 120.56L160.246 116.495Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 122.553L167.253 120.54L167.253 124.606L170.74 126.619L170.74 122.553Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 124.566L170.739 122.553L170.739 126.619L174.225 128.631L174.225 124.566Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 126.578L174.225 124.566L174.225 128.631L177.711 130.644L177.711 126.578Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M191.656 134.629L188.17 132.616L188.17 136.682L191.656 138.695L191.656 134.629Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 144.713L205.635 142.7L205.635 146.766L209.121 148.778L209.121 144.713Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 146.725L209.121 144.713L209.121 148.778L212.607 150.791L212.607 146.725Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 102.426L125.351 100.413L125.351 104.479L128.837 106.492L128.837 102.426Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 106.451L132.323 104.439L132.323 108.504L135.809 110.517L135.809 106.451Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 108.464L135.809 106.451L135.809 110.517L139.295 112.53L139.295 108.464Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 110.497L139.33 108.484L139.33 112.55L142.816 114.563L142.816 110.497Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 114.522L146.302 112.51L146.302 116.575L149.788 118.588L149.788 114.522Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 120.56L156.76 118.548L156.76 122.613L160.246 124.626L160.246 120.56Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 124.606L163.767 122.593L163.767 126.659L167.253 128.671L167.253 124.606Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 128.631L170.739 126.619L170.739 130.684L174.225 132.697L174.225 128.631Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 132.657L177.712 130.644L177.712 134.71L181.198 136.722L181.198 132.657Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M188.17 136.682L184.684 134.669L184.684 138.735L188.17 140.748L188.17 136.682Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 142.74L195.177 140.728L195.177 144.793L198.663 146.806L198.663 142.74Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 144.753L198.663 142.74L198.663 146.806L202.149 148.819L202.149 144.753Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 146.766L202.149 144.753L202.149 148.819L205.635 150.831L205.635 146.766Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 148.778L205.635 146.766L205.635 150.831L209.121 152.844L209.121 148.778Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 150.791L209.121 148.778L209.121 152.844L212.607 154.857L212.607 150.791Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 106.492L125.351 104.479L125.351 108.545L128.837 110.557L128.837 106.492Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 118.588L146.302 116.575L146.302 120.641L149.788 122.654L149.788 118.588Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 122.613L153.274 120.601L153.274 124.666L156.76 126.679L156.76 122.613Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 126.639L160.246 124.626L160.246 128.692L163.732 130.704L163.732 126.639Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M167.253 128.672L163.767 126.659L163.767 130.724L167.253 132.737L167.253 128.672Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M177.711 134.71L174.225 132.697L174.225 136.763L177.711 138.775L177.711 134.71Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M181.198 136.722L177.712 134.71L177.712 138.775L181.198 140.788L181.198 136.722Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M195.177 144.793L191.69 142.78L191.69 146.846L195.177 148.859L195.177 144.793Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M198.663 146.806L195.177 144.793L195.177 148.859L198.663 150.872L198.663 146.806Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M205.635 150.831L202.149 148.819L202.149 152.884L205.635 154.897L205.635 150.831Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M209.121 152.844L205.635 150.831L205.635 154.897L209.121 156.91L209.121 152.844Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 154.857L209.121 152.844L209.121 156.91L212.607 158.922L212.607 154.857Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M128.837 110.557L125.351 108.545L125.351 112.61L128.837 114.623L128.837 110.557Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M132.323 112.57L128.836 110.557L128.836 114.623L132.323 116.636L132.323 112.57Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M135.809 114.583L132.323 112.57L132.323 116.636L135.809 118.648L135.809 114.583Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M139.295 116.595L135.809 114.583L135.809 118.648L139.295 120.661L139.295 116.595Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M142.816 118.628L139.33 116.615L139.33 120.681L142.816 122.694L142.816 118.628Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M146.302 120.641L142.816 118.628L142.816 122.694L146.302 124.706L146.302 120.641Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M149.788 122.654L146.302 120.641L146.302 124.706L149.788 126.719L149.788 122.654Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M156.76 126.679L153.274 124.666L153.274 128.732L156.76 130.745L156.76 126.679Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 128.692L156.76 126.679L156.76 130.745L160.246 132.757L160.246 128.692Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M163.732 130.704L160.246 128.692L160.246 132.757L163.732 134.77L163.732 130.704Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M170.74 134.75L167.253 132.737L167.253 136.803L170.74 138.815L170.74 134.75Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M184.683 142.801L181.197 140.788L181.197 144.854L184.683 146.866L184.683 142.801Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M188.17 144.813L184.684 142.801L184.684 146.866L188.17 148.879L188.17 144.813Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M202.149 152.884L198.663 150.871L198.663 154.937L202.149 156.95L202.149 152.884Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M212.607 158.922L209.121 156.91L209.121 160.975L212.607 162.988L212.607 158.922Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M119.399 60.4073L60.8579 125.896L107.804 152.715L221.617 119.409L119.399 60.4073Z",
    fill: "url(#paint0_linear_1837_9363)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1429 252.379C27.1429 252.379 31.8426 250.948 33.4773 251.561C35.1119 252.174 37.9726 253.502 37.9726 254.064C37.9726 254.626 32.3023 257.64 30.4123 258.253C28.5222 258.866 21.8813 258.151 22.0857 258.253C22.29 258.355 27.1429 252.379 27.1429 252.379Z",
    fill: "#2E383B"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8144 189.24L29.1349 258.253L13.9121 257.845L34.8563 191.027L58.8144 189.24Z",
    fill: "url(#paint1_linear_1837_9363)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2683 170.85L0.426271 257.691C0.426271 257.691 -1.87248 265.098 4.20644 268.419C11.2049 272.25 25.0995 266.784 37.9725 258.253V254.064C37.9725 254.064 22.8519 259.275 26.0701 248.139C29.2373 237.002 43.796 199.916 48.8533 196.034C53.8595 192.1 59.2232 190.874 59.2232 190.874L66.0173 174.425L21.2683 170.85Z",
    fill: "url(#paint2_linear_1837_9363)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1101 166.967C42.3656 166.61 42.6721 166.201 43.0296 165.843C48.1891 159.662 70.819 145.768 55.9027 135.857C39.4538 124.926 15.9044 150.161 15.9044 150.161L15.3936 151.744L19.4802 153.277C19.4802 153.277 40.1179 166.456 40.1179 166.507C40.0668 166.507 40.9352 166.712 42.1101 166.967Z",
    fill: "url(#paint3_linear_1837_9363)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3438 182.905C41.3438 182.905 33.528 177.235 43.0296 165.843C48.189 159.662 70.8189 145.768 55.9026 135.857C39.4537 124.926 15.9043 150.161 15.9043 150.161C15.9043 150.161 23.2092 135.142 35.2649 123.393C47.3206 111.644 60.0403 103.42 60.0403 103.42L62.3901 101.989L71.7384 101.07L91.712 107.915L107.088 121.452L113.065 136.777L109.183 151.795L108.212 164.72L103.87 167.989C103.87 167.989 93.9086 172.024 86.3483 174.579C75.5186 178.206 53.1951 184.795 41.3438 182.905Z",
    fill: "url(#paint4_radial_1837_9363)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2033 139.28C48.9556 138.054 46.4525 137.594 43.4897 137.492C41.7018 137.441 37.2575 138.361 37.6151 137.492C38.4324 135.551 42.5191 133.916 46.1971 134.018C49.4154 134.121 52.6847 134.989 55.2389 136.726C58.0995 138.616 59.3766 140.302 59.6831 143.213C59.8874 145.104 58.9169 147.964 58.0484 147.913C57.18 147.862 56.8224 146.738 56.6692 145.972C56.1584 143.673 54.9834 141.374 51.2033 139.28Z",
    fill: "#0F53B9"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0484 147.607C57.5887 147.556 57.2311 147.045 56.9757 145.972C56.5159 143.826 55.4943 141.323 51.3565 139.076C49.2621 137.901 46.8101 137.339 43.4897 137.237C43.4386 137.237 43.3875 137.237 43.2853 137.237C42.6212 137.237 41.7017 137.339 40.8333 137.441C39.9649 137.543 39.0965 137.645 38.4835 137.645C38.2281 137.645 38.0748 137.645 37.9727 137.594C38.79 135.96 42.468 134.478 45.8395 134.478C45.9417 134.478 46.0949 134.478 46.1971 134.478C49.5175 134.58 52.6336 135.5 55.0345 137.135C57.8952 139.025 59.019 140.659 59.3255 143.367C59.4787 144.848 58.9168 146.84 58.3038 147.504C58.2017 147.556 58.0995 147.607 58.0484 147.607Z",
    fill: "#5099DA"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9971 147.249C57.7417 147.198 57.4863 146.687 57.2819 145.87C56.8222 143.673 55.7494 141.068 51.5095 138.718C49.364 137.543 46.8609 136.93 43.5405 136.828C43.4894 136.828 43.4384 136.828 43.3362 136.828C42.6721 136.828 41.7526 136.93 40.8331 137.032C40.0158 137.135 39.1474 137.186 38.5854 137.237C39.7604 135.857 42.9786 134.734 45.8904 134.734C45.9925 134.734 46.0947 134.734 46.248 134.734C49.4662 134.836 52.5823 135.755 54.9321 137.339C57.6906 139.178 58.8144 140.761 59.0699 143.316C59.2231 144.797 58.6101 146.636 58.1504 147.198C58.0482 147.198 58.0482 147.249 57.9971 147.249Z",
    fill: "#5099DA"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9976 146.789C57.8954 146.636 57.7421 146.33 57.64 145.768C57.1291 143.469 56.0564 140.813 51.6632 138.412C49.4666 137.186 46.9635 136.624 43.541 136.522C43.4899 136.522 43.3877 136.522 43.3366 136.522C42.6725 136.522 41.702 136.624 40.8335 136.726C40.3738 136.777 39.9651 136.828 39.5054 136.879C40.9357 135.857 43.541 135.091 45.8908 135.091C45.993 135.091 46.0951 135.091 46.1973 135.091C49.3645 135.193 52.3784 136.062 54.7282 137.594C57.4356 139.382 58.4573 140.864 58.7127 143.367C58.866 144.542 58.4062 146.125 57.9976 146.789Z",
    fill: "#5099DA"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M41.344 182.905C41.344 182.905 33.5282 177.235 43.0297 165.843C48.1891 159.662 63.6163 148.015 50.8455 140.353C37.9214 132.588 15.3936 151.744 15.3936 151.744C15.3936 151.744 11.1537 157.568 10.3363 164.413C9.51902 171.258 14.0144 174.732 21.0128 178.052C28.0112 181.322 41.344 182.905 41.344 182.905Z",
    fill: "url(#paint5_radial_1837_9363)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M118.582 145.104C120.268 139.178 127.113 129.319 124.303 122.627C121.545 115.935 108.365 108.426 98.9149 102.602C89.4644 96.7276 79.3499 92.2834 75.8763 93.6115L59.4785 102.5C60.1937 102.091 61.7773 101.989 63.0033 102.296C67.0388 103.164 73.4243 105.514 86.4505 113.687C99.4257 121.81 106.628 127.122 109.285 131.515C111.328 134.785 110.306 143.009 106.22 145.768C100.396 149.701 70.5636 165.997 67.6519 167.631C64.7401 169.266 62.85 170.543 63.0033 172.024C63.1565 173.506 66.3237 173.659 71.7385 172.382C79.2989 170.645 95.1858 164.617 98.9149 162.778C102.644 160.939 106.118 158.845 106.68 159.458C107.241 160.071 106.577 163.851 106.22 165.333C105.811 167.069 105.3 168.295 104.585 168.908L117.152 160.939C117.152 160.939 119.297 159.867 119.297 156.597C119.348 153.328 116.896 151.029 118.582 145.104Z",
    fill: "url(#paint6_linear_1837_9363)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0545 171.922C62.9012 170.441 64.8424 169.164 67.7031 167.529C70.6148 165.894 100.448 149.599 106.271 145.665C110.358 142.907 111.328 134.734 109.336 131.413C106.629 127.02 99.4258 121.707 86.5017 113.585C73.4755 105.412 67.0901 103.062 63.0545 102.194C61.9307 101.938 60.5003 101.989 59.7341 102.347C59.7341 102.347 59.2743 102.5 58.9678 103.164C58.8146 103.42 58.7124 104.339 58.7124 104.339L60.0916 103.42C60.296 103.317 60.8579 103.215 61.5731 103.215C62.0328 103.215 62.4415 103.266 62.8502 103.317C66.2727 104.033 72.3517 106.025 85.9909 114.556C97.4847 121.758 105.709 127.48 108.468 132.026C110.153 134.734 109.387 142.345 105.76 144.797C100.958 148.066 78.9925 160.173 70.717 164.72C68.9802 165.69 67.7541 166.354 67.2944 166.61C64.2294 168.346 61.8796 169.828 62.0839 172.076C62.135 172.74 62.9523 172.944 64.3316 172.995C63.5142 172.791 63.1056 172.433 63.0545 171.922Z",
    fill: "url(#paint7_linear_1837_9363)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M104.636 168.806C105.352 168.193 105.862 166.967 106.22 165.23C106.578 163.749 107.242 159.969 106.68 159.356C106.526 159.203 106.22 159.203 105.76 159.356C105.76 160.837 105.505 163.545 105.147 165.026C104.79 166.61 104.381 167.58 103.87 167.989L102.133 168.704C102.133 168.704 102.746 169.011 103.359 169.011C104.534 168.96 104.636 168.806 104.636 168.806Z",
    fill: "#151F22"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0078 122.32C77 123.342 78.0217 124.721 78.3793 125.947C78.4814 126.305 78.6858 126.867 78.3793 127.122C77.9706 127.429 77.3065 127.429 76.8978 127.224C76.4892 126.969 76.5913 126.56 76.5403 126.254C76.2848 125.232 75.6208 124.21 73.9861 123.291C72.4536 122.423 70.5124 121.912 68.8267 121.81C68.1626 121.758 67.4985 121.81 67.1409 121.656C66.6812 121.452 66.6812 120.992 67.192 120.788C67.7028 120.584 68.5713 120.686 69.1332 120.737C70.9722 120.839 73.1688 121.35 75.0078 122.32Z",
    fill: "#2E383B"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5562 123.546C74.1909 124.364 75.0082 125.385 75.2125 126.305C75.3147 126.611 75.4169 127.071 75.0593 127.327C74.6506 127.633 73.9354 127.582 73.5779 127.327C73.1692 127.02 73.3735 126.662 73.2714 126.356C73.067 125.743 72.5051 125.028 71.2791 124.415C70.2574 123.904 69.1336 123.7 68.0608 123.649C67.55 123.597 67.1413 123.649 66.7838 123.393C66.5283 123.189 66.4773 122.933 66.8859 122.678C67.3457 122.423 68.1119 122.525 68.6739 122.576C69.8999 122.627 71.2791 122.933 72.5562 123.546Z",
    fill: "#2E383B"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5128 125.028C71.5345 125.539 71.9942 126.203 72.0453 126.816C72.0453 127.02 72.0453 127.224 71.892 127.378C71.4834 127.735 70.666 127.684 70.3085 127.378C70.053 127.173 70.1552 126.816 70.053 126.611C69.8487 126.101 68.9803 125.641 68.1119 125.488C67.4989 125.385 67.0391 125.539 66.5794 125.232C66.2218 124.977 66.324 124.619 66.8348 124.466C67.3456 124.262 68.1119 124.364 68.6227 124.415C69.3379 124.517 69.9509 124.721 70.5128 125.028Z",
    fill: "#2E383B"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M119.399 60.4073L118.991 60.8671C119.042 60.9182 119.042 60.9182 119.093 60.9182L220.8 119.613L221.617 119.358L119.399 60.4073Z",
    fill: "#FF0012"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1837_9363",
    x1: 125.246,
    y1: 73.6318,
    x2: 88.7913,
    y2: 129.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4342",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142361,
    stopColor: "#FF4342",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7394,
    stopColor: "#FF4342"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1837_9363",
    x1: 36.8215,
    y1: 223.724,
    x2: 44.1157,
    y2: 226.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#799299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    stopColor: "#779096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6491,
    stopColor: "#70878E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8553,
    stopColor: "#657A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1837_9363",
    x1: 26.289,
    y1: 219.051,
    x2: 19.6465,
    y2: 217.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E383B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1837_9363",
    x1: 33.2941,
    y1: 141.603,
    x2: 51.8988,
    y2: 158.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F787F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50656B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1837_9363",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-41.0734 -73.0972) scale(280.217 280.217)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8962,
    stopColor: "#799299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9051,
    stopColor: "#819CA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#87A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9353,
    stopColor: "#62777D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#364247"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1837_9363",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6997 120.555) scale(55.5574 55.5574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2506,
    stopColor: "#414E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8962,
    stopColor: "#414E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9046,
    stopColor: "#48575B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#4F5F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9599,
    stopColor: "#2E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E383B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1837_9363",
    x1: 89.5178,
    y1: 139.774,
    x2: 93.7747,
    y2: 147.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E383B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1837_9363",
    x1: 55.2106,
    y1: 167.385,
    x2: 89.1099,
    y2: 114.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0372977,
    stopColor: "#4F5F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7328,
    stopColor: "#4E5E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8349,
    stopColor: "#14181A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQr);
export default __webpack_public_path__ + "static/media/ScanQr.67233f1c2aebb481098b98860b010bef.svg";
export { ForwardRef as ReactComponent };